/**
 * Einfacher Markdown-zu-HTML Konverter fuer Chat-Nachrichten.
 * Unterstuetzt: **bold**, *italic*, `inline code`, ```code blocks```,
 * Tabellen (| ... |), Ueberschriften (#/##/###), Zeilenumbrueche
 */

// Markdown-Tabellenblöcke (| Zelle | Zelle |) in <table> umwandeln.
// Läuft NACH dem HTML-Escaping — Zelleninhalte sind bereits sicher.
function renderTables(html) {
  const lines = html.split('\n')
  const out = []
  let i = 0
  const isRow = l => /^\s*\|.*\|\s*$/.test(l)
  const isSep = l => /^\s*\|[\s\-:|]+\|\s*$/.test(l)
  const cells = l => l.trim().replace(/^\|/, '').replace(/\|$/, '').split('|').map(c => c.trim())
  while (i < lines.length) {
    // Tabellenstart: Zeile + Trennzeile (|---|---|)
    if (isRow(lines[i]) && i + 1 < lines.length && isSep(lines[i + 1])) {
      const header = cells(lines[i])
      i += 2
      const rows = []
      while (i < lines.length && isRow(lines[i]) && !isSep(lines[i])) {
        rows.push(cells(lines[i]))
        i++
      }
      const thead = `<thead><tr>${header.map(h => `<th>${h}</th>`).join('')}</tr></thead>`
      const tbody = `<tbody>${rows.map(r => `<tr>${r.map(c => `<td>${c}</td>`).join('')}</tr>`).join('')}</tbody>`
      out.push(`<table class="chat-md-table">${thead}${tbody}</table>`)
      continue
    }
    out.push(lines[i])
    i++
  }
  return out.join('\n')
}
export function renderMarkdown(text) {
  if (!text) return ''
  let html = text
    // HTML-Sonderzeichen escapen
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')

  // Code-Bloecke (```...```)
  html = html.replace(/```(\w*)\n?([\s\S]*?)```/g, (_, lang, code) =>
    `<pre><code>${code.trim()}</code></pre>`
  )

  // Inline-Code (`...`)
  html = html.replace(/`([^`]+)`/g, '<code>$1</code>')

  // Bold (**...**)
  html = html.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>')

  // Italic (*...*)
  html = html.replace(/(?<!\*)\*([^*]+)\*(?!\*)/g, '<em>$1</em>')

  // Links [text](url) — interne API-Links mit Auth-Token versehen
  // Sicherheit: nur http(s)/mailto/tel und relative Pfade zulassen (kein javascript: etc.),
  // Anführungszeichen encodieren damit kein Attribut-Ausbruch möglich ist.
  html = html.replace(/\[([^\]]+)\]\(([^)]+)\)/g, (_, text, url) => {
    const clean = url.trim().replace(/"/g, '%22').replace(/'/g, '%27')
    const isSafe = /^(https?:|mailto:|tel:)/i.test(clean) || (clean.startsWith('/') && !clean.startsWith('//'))
    if (!isSafe) return text
    if (clean.startsWith('/api/')) {
      const token = localStorage.getItem('agent_token')
      const sep = clean.includes('?') ? '&' : '?'
      const authUrl = token ? `${clean}${sep}token=${token}` : clean
      return `<a href="${authUrl}" download class="chat-download-link">⤓ ${text}</a>`
    }
    return `<a href="${clean}" target="_blank" rel="noopener">${text}</a>`
  })

  // Ueberschriften (#, ##, ###) — zeilenweise, vor dem <br>-Replace
  html = html.replace(/^###\s+(.+)$/gm, '<h4 class="chat-md-h">$1</h4>')
  html = html.replace(/^##\s+(.+)$/gm, '<h3 class="chat-md-h">$1</h3>')
  html = html.replace(/^#\s+(.+)$/gm, '<h3 class="chat-md-h">$1</h3>')

  // Tabellen (| ... |) — MUSS vor dem <br>-Replace laufen (braucht Zeilenstruktur)
  html = renderTables(html)

  // Zeilenumbrueche
  html = html.replace(/\n/g, '<br>')

  // Keine <br> direkt nach Block-Elementen (haben eigenen Abstand)
  html = html.replace(/(<\/(?:table|h3|h4)>)<br>/g, '$1')

  return html
}
